import { render, staticRenderFns } from "./MyNews2.vue?vue&type=template&id=30b76aa8&scoped=true"
import script from "./MyNews2.vue?vue&type=script&lang=js"
export * from "./MyNews2.vue?vue&type=script&lang=js"
import style0 from "./MyNews2.vue?vue&type=style&index=0&id=30b76aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b76aa8",
  null
  
)

export default component.exports